import { onCommonResult } from '../utils';
/**
 * onCommonResult回调对应的页面代码
 */
export var BusinessCode;
(function (BusinessCode) {
    /**
     * 个股搜索
     */
    BusinessCode[BusinessCode["StockSearch"] = 10002] = "StockSearch";
    /**
     * 券商金股
     */
    BusinessCode[BusinessCode["GoldStockBroker"] = 10004] = "GoldStockBroker";
})(BusinessCode || (BusinessCode = {}));
export var StockSearchType;
(function (StockSearchType) {
    /**
     * 所有股票（包括板块、指数等）
     */
    StockSearchType[StockSearchType["All"] = 0] = "All";
    /**
     * 只搜索A股
     */
    StockSearchType[StockSearchType["A"] = 1] = "A";
})(StockSearchType || (StockSearchType = {}));
/**
 * 打开股票搜索页
 * @param options
 */
export function openStockSearch(options) {
    onCommonResult(BusinessCode.StockSearch, options.callback);
    if (window.goods && window.goods.openStockSearch) {
        window.goods.openStockSearch(JSON.stringify(options));
    }
    else {
        console.info('goods or goods.openStockSearch is undefined');
    }
}
/**
 * 打开券商金股券商搜索页
 * @param options
 */
export function openGoldStockBrokerSearch(options) {
    onCommonResult(BusinessCode.GoldStockBroker, options.callback);
    if (window.goods && window.goods.openGoldStockBrokerSearch) {
        window.goods.openGoldStockBrokerSearch(JSON.stringify(options));
    }
    else {
        console.info('goods or goods.openGoldStockBrokerSearch is undefined');
    }
}
//# sourceMappingURL=onCommonResult.js.map